import UpdateButton from "../Profile/SkladSettings/UpdateButton/UpdateButton";
import React from "react";

export default function NoResultMessageWithUpdateButton() {
    return <>Нет нужного поля? <UpdateButton /></>
}